// extracted by mini-css-extract-plugin
export default {"row":"_2Mp8aW7pyIXvYH2PRo9hyQ==","zipcodeCity":"iAoTOXYNcUkkMjJMqp3DpQ=="};